<template>
    <div class="game-limit">
        <van-nav-bar  :title="t('gameLimit.title')" class="custom-nav-bar" :border="false">
        <template #left>
          <Button type="back" @click="onClickLeft" />
        </template>

        </van-nav-bar>
        <div class="h-[calc(100vh-56px)] overflow-hidden">
            <div class="mx-[8px] mt-[16px] ">
                <!-- 类型选择区域 -->
                <div class="type-selection">
                    <div class="type-scroll-container">
                        <div class="type-list">
                            <div v-for="(item, index) in vendorList" :key="index"
                                @click="onTypeClick(item)"
                                :class="{
                                    'bg-gradient-to-r from-[#13C769] to-[#1C9B56]': item.active,
                                    'bg-[linear-gradient(to_right,#007E5B_0%,#007E5B_50%,#006C4C_100%)]': !item.active
                                }"
                                class="type-item">
                                <div class="flex items-center">
                                    <img :src="getGameTypeIcon(item.gameType)" alt="" class="type-icon"
                                        :class="{ 'saturate-100': item.active, 'saturate-10': !item.active }">
                                    <span class="type-name" :class="{ 'text-[#ffffff] font-bold': item.active, 'text-[#4CAE83]': !item.active }">
                                        {{ item.gameType }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="h-[1px] bg-[#007E5B] mx-[10px] mt-[10px]"></div>
            <div class="h-[calc(100%-68px)] overflow-hidden mx-[10px] flex mt-[20px]">
                <!-- 左侧厂商列表 -->
                <div class="w-[73px] h-full overflow-y-auto mr-[7px] flex-shrink-0">
                    <div v-for="(vendor, index) in getCurrentVendors()" :key="index" @click="onVendorClick(vendor)"
                        :class="{ 'bg-gradient-to-r from-[#13C769] to-[#1C9B56]': vendor.active }"
                        class="mb-[15px] w-full h-[60px] bg-[linear-gradient(to_right,#007E5B_0%,#007E5B_50%,#006C4C_100%)] rounded-[10px] flex justify-center items-center">
                        <div>
                                <div class="max-w-[30px] h-[30px] flex justify-center items-center">
                                    <img class="max-w-full max-h-full w-auto h-auto saturate-10"
                                        :class="{ 'saturate-100': vendor.active }"
                                        :src="IMG_URL + vendor.icon" alt="">
                                </div>
                                <div class="text-[10px] text-bold text-[#ffffff] mt-[5px]"
                                    :class="{ 'teonse': vendor.active }">{{
                                        vendor.name }}</div>
                        </div>
                    </div>
                </div>

                <!-- 右侧游戏列表 -->
                <div class="w-full h-full" id="game-limit-nav">
                    <div class="h-full overflow-y-auto" @scroll="handleScroll">
                        <div class="game-list grid grid-cols-3 gap-[10px]">
                            <div v-for="item in games" :key="item.id" class="game-card relative"
                                @click="gogames(item)">
                                <img :src="item.imageSquare" alt=""
                                    class="w-full h-full object-cover rounded-[10px]" />
                                <!-- 收藏按钮 -->
                                <img v-if="!item.collect" :src="getAssetsFile('home/favorite_off.png')" alt=""
                                    class="absolute top-[2px] right-[4px] w-[25px] h-[25px]"
                                    @click.stop="gocollect(item)">
                                <img v-else :src="getAssetsFile('home/favorite_offx.png')" alt=""
                                    class="absolute top-[2px] right-[4px] w-[25px] h-[25px]"
                                    @click.stop="gocollect2(item)">
                            </div>
                        </div>
                        <!-- 加载状态 -->
                        <div v-if="loading" class="flex justify-center items-center py-4">
                            <div class="text-[#4CAE83] text-sm">{{ t('findGameByVendor.loading') }}</div>
                        </div>

                        <!-- 没有更多数据 -->
                        <div v-if="!hasMore && games.length > 0" class="flex justify-center items-center py-4">
                            <div class="text-[#4CAE83] text-sm">{{ t('findGameByVendor.noMoreGames') }}</div>
                        </div>

                        <!-- 空状态 -->
                        <div v-if="!loading && games.length === 0" class="flex justify-center items-center py-8">
                            <div class="text-[#4CAE83] text-sm">{{ t('findGameByVendor.noGamesFound') }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { Button } from "@/components/Button"
import { useI18n } from 'vue-i18n'
import { getAssetsFile } from '@/utils/pub-use'
import { useUserStore } from '@/stores/modules/user'
import * as GameApi from '@/api/game'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()
const userStore = useUserStore()

// 从路由参数获取 drawId 和 activityId
const drawId = ref(Number(route.query.drawId) || 0)
const activityId = ref(Number(route.query.activityId) || 0)
const  IMG_URL = import.meta.env.VITE_IMG_URL
let  parmes = ref({
    activityId: activityId.value,
    drawId: drawId.value,
})
// 游戏类型列表
const gameTypeList = ref([
    {
        id: 1,
        name: t('relatorios.bettingStatistics.slots'),
        type: 'SLOTS',
        icon: getAssetsFile('game/gameTypeSlot.png'),
        active: true
    },
    {
        id: 2,
        name: t('relatorios.bettingStatistics.fishing'),
        type: 'FISH',
        icon: getAssetsFile('game/FISHING_on.png'),
        active: false
    },
    {
        id: 3,
        name: t('relatorios.bettingStatistics.chess'),
        type: 'CHESS',
        icon: getAssetsFile('game/CHESS_on.png'),
        active: false
    },
    {
        id: 4,
        name: t('relatorios.bettingStatistics.hall'),
        type: 'HALL',
        icon: getAssetsFile('game/VIDEO_on.png'),
        active: false
    },
    {
        id: 5,
        name: t('relatorios.bettingStatistics.videoGame'),
        type: 'VIDEO_GAME',
        icon: getAssetsFile('game/VIDEO_on.png'),
        active: false
    },
    {
        id: 6,
        name: t('relatorios.bettingStatistics.live'),
        type: 'LIVE',
        icon: getAssetsFile('game/gameTypeSlot.png'),
        active: false
    },
    {
        id: 7,
        name: t('relatorios.bettingStatistics.arcades'),
        type: 'ARCADES',
        icon: getAssetsFile('game/gameTypeSlot.png'),
        active: false
    }
])

// 厂商列表
const vendorList = ref([])

// 快速选项列表 - 使用 findGameByVendor 的多语言
// const quickOptionList = ref([
//     {
//         label: t('findGameByVendor.all'),
//         value: undefined,
//         active: true
//     },
//     {
//         label: t('findGameByVendor.popular'),
//         value: 'popular',
//         active: false
//     },
//     {
//         label: t('findGameByVendor.recent'),
//         value: 'recente',
//         active: false
//     },
//     {
//         label: t('findGameByVendor.favorites'),
//         value: 'favoritos',
//         active: false
//     }
// ])

// 游戏列表
const games = ref([])
const loading = ref(false)
const hasMore = ref(true)
const isSwitching = ref(false) // 是否正在切换类型/厂商

// 当前页码
const currentPage = ref(1)
const pageSize = ref(30)

// 获取厂商图标
const getVendorIcon = (item: any) => {
    if (item.logo) {
        return getAssetsFile(`vendor/${item.name.toLowerCase()}.png`)
    }
    return ''
}

// 获取当前选中类型的厂商列表
const getCurrentVendors = () => {
  const selectedType = vendorList.value.find(item => item.active)
  return selectedType?.vendors || []
}

// 类型点击事件
const onTypeClick = (item: any) => {
  isSwitching.value = true // 设置切换标志

  vendorList.value.forEach(type => {
    type.active = false
  })
  item.active = true

  // 重置所有厂商的选中状态
  vendorList.value.forEach(type => {
    type.vendors.forEach(vendor => {
      vendor.active = false
    })
  })

  // 选中当前类型的第一个厂商
  if (item.vendors && item.vendors.length > 0) {
    item.vendors[0].active = true
  }

  currentPage.value = 1 // 重置页码
  hasMore.value = true // 重置hasMore状态

  getGameList()

  // 延迟滚动，确保数据加载完成后再滚动
  setTimeout(() => {
    scrollToTop()
  }, 100)
}

// 厂商点击事件
const onVendorClick = (vendor: any) => {
  isSwitching.value = true // 设置切换标志

  // 重置所有厂商的选中状态
  vendorList.value.forEach(type => {
    type.vendors.forEach(v => {
      v.active = false
    })
  })
  vendor.active = true
  currentPage.value = 1 // 重置页码
  hasMore.value = true // 重置hasMore状态

  getGameList()

  // 延迟滚动，确保数据加载完成后再滚动
  setTimeout(() => {
    scrollToTop()
  }, 100)
}

// 获取游戏列表时使用选中的厂商
const getGameList = async () => {
  loading.value = true
  try {
    const selectedType = vendorList.value.find(item => item.active)
    const selectedVendor = getCurrentVendors().find(vendor => vendor.active)

    // 添加调试信息
    console.log('selectedType:', selectedType)
    console.log('selectedVendor:', selectedVendor)
    console.log('getCurrentVendors():', getCurrentVendors())

    const params = {
      pageNo: currentPage.value,
      pageSize: pageSize.value,
      vendorId: selectedVendor?.id || 0,
      categoryCode: selectedType?.gameType || "string",
      activityId: activityId.value,
      drawId: drawId.value,
      offset: 0
    }

    console.log('请求参数:', params)

    const res = await GameApi.getAudioGames(params)

    if (res.data && res.data.list) {
      games.value = res.data.list.map(item => ({
        id: item.id,
        name: item.gameName,
        imageSquare: item.imageSquare,
        collect: item.isCollected || false,
        gameCode: item.gameCode,
        providerId: item.providerId
      }))
      // 后端hasMore字段可能有问题，我们自己计算
      const total = res.data.total || 0
      const currentLoaded = games.value.length
      hasMore.value = currentLoaded < total

    } else {
      games.value = []
      hasMore.value = false
      console.log('初始加载失败或无数据')
    }
  } catch (error) {
    console.error('获取游戏列表失败:', error)
    games.value = []
    hasMore.value = false
  } finally {
    loading.value = false
    isSwitching.value = false // 清除切换标志
  }
}

// 初始化时设置第一个类型和第一个厂商为选中状态
const initializeSelection = () => {
  if (vendorList.value.length > 0) {
    // 选中第一个类型
    vendorList.value[0].active = true

    // 选中第一个厂商
    if (vendorList.value[0].vendors.length > 0) {
      vendorList.value[0].vendors[0].active = true
    }

    console.log('初始化选中状态完成')
    console.log('选中的类型:', vendorList.value[0])
    console.log('选中的厂商:', vendorList.value[0].vendors[0])
  }
}

// 加载更多数据
const loadMore = async () => {
  if (loading.value || !hasMore.value) return

  loading.value = true
  try {
    currentPage.value++

    // 获取当前选中的类型和厂商
    const selectedType = vendorList.value.find(item => item.active)
    const selectedVendor = getCurrentVendors().find(vendor => vendor.active)

    // 构建请求参数
    const params = {
      pageNo: currentPage.value,
      pageSize: pageSize.value,
      vendorId: selectedVendor?.id || 0,
      categoryCode: selectedType?.gameType || "string",
      activityId: activityId.value, // 使用从路由获取的 activityId
      drawId: drawId.value, // 使用从路由获取的 drawId
      offset: 0
    }

    // 调用接口
    const res = await GameApi.getAudioGames(params)

    if (res.data && res.data.list) {
      const newGames = res.data.list.map(item => ({
        id: item.id,
        name: item.gameName,
        imageSquare: item.imageSquare,
        collect: item.isCollected || false,
        providerId: item.vendorId,
        gameCode: item.gameCode
      }))

      // 追加到现有列表
      games.value = [...games.value, ...newGames]

      // 后端hasMore字段可能有问题，我们自己计算
      const total = res.data.total || 0
      const currentLoaded = games.value.length
      hasMore.value = currentLoaded < total

    } else {
      console.log('没有更多数据')
      hasMore.value = false
    }
  } catch (error) {
    console.error('加载更多游戏失败:', error)
    currentPage.value-- // 失败时回退页码
  } finally {
    loading.value = false
  }
}

// 收藏游戏 - 使用相同的接口
const gocollect = (item: any) => {
    GameApi.collect({ gameId: item.id }).then((res) => {
        item.collect = true
    })
}

// 取消收藏 - 使用相同的接口
const gocollect2 = (item: any) => {
    GameApi.uncollect({ gameId: item.id }).then((res) => {
        item.collect = false
    })
}

// 进入游戏 - 使用相同的接口
const VITE_PLATFORM = import.meta.env.VITE_PLATFORM
async function gogames(row: any) {
    const a = userStore.checkLoginStatus()
    if (a) {
        const gamesid = {
            platformId: row.providerId,
            currency: VITE_PLATFORM,
            disableFullScreen: 0,
            gameId: row.gameCode,
            lang: 'en',
            homeUrl: import.meta.env.VITE_BASE_URL || window.location.origin,
            platform: 'H5',
            id: row.id,
        }
        const gameUrl = await GameApi.thirdPartygoGame(gamesid)

        // 记录来源路径
        sessionStorage.setItem('fromPath', route.path)

        // 使用 query 参数传递 URL
        router.push({
            path: '/webview/index2',
            query: {
                rid: gameUrl.data,
            },
        })
    } else {
        window.$showLoginDialog()
    }
}

// 返回上一页
const onClickLeft = () => {
    router.back()
}

// 防抖函数
const debounce = (func, wait) => {
    let timeout
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout)
            func(...args)
        }
        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
    }
}

// 滚动监听函数 - 实现上拉加载
const handleScrollInternal = (event) => {
    const { scrollTop, scrollHeight, clientHeight } = event.target

    // 当滚动到底部附近时触发加载更多
    if (scrollTop + clientHeight >= scrollHeight - 100) {
        // 添加保护：只有在非加载状态、有更多数据且不在切换状态时才触发
        if (!loading.value && hasMore.value && !isSwitching.value) {
            loadMore()
        }
    }
}

// 使用防抖的滚动处理函数
const handleScroll = debounce(handleScrollInternal, 100)

// 滚动到页面顶部
const scrollToTop = () => {
  // 专门查找右侧游戏列表的滚动容器
  // 排除左侧厂商列表（w-[73px]），只找右侧的容器
  const allScrollContainers = document.querySelectorAll('[class*="overflow-y-auto"]')
  let gameListContainer = null

  // 遍历所有滚动容器，找到右侧的游戏列表容器
  allScrollContainers.forEach(container => {
    const className = container.className
    // 排除左侧厂商列表（包含 w-[73px] 的容器）
    if (!className.includes('w-[73px]') && className.includes('h-full')) {
      gameListContainer = container
    }
  })

  console.log('所有滚动容器:', allScrollContainers)
  console.log('找到的游戏列表容器:', gameListContainer)
  console.log('容器类名:', gameListContainer?.className)

  if (gameListContainer) {
    // 检查容器是否有滚动内容
    console.log('容器滚动信息:', {
      scrollHeight: gameListContainer.scrollHeight,
      clientHeight: gameListContainer.clientHeight,
      scrollTop: gameListContainer.scrollTop,
      hasScrollbar: gameListContainer.scrollHeight > gameListContainer.clientHeight
    })

    // 直接设置滚动位置为顶部
    gameListContainer.scrollTop = 0
    console.log('滚动到顶部，scrollTop设置为:', gameListContainer.scrollTop)

    // 验证滚动是否生效
    setTimeout(() => {
      console.log('滚动后验证，scrollTop:', gameListContainer.scrollTop)
    }, 50)
  } else {
    console.log('未找到游戏列表滚动容器')
  }
}

// 游戏类型图标枚举 - 通过 gameType 匹配图标
const getGameTypeIcon = (gameType: string) => {
  const iconMap: Record<string, string> = {
    'SLOTS': getAssetsFile('game/gameTypeSlot.png'),
    'FISH': getAssetsFile('game/FISHING_on.png'),
    'CHESS': getAssetsFile('game/CHESS_on.png'),
    'HALL': getAssetsFile('game/VIDEO_on.png'),
    'VIDEO_GAME': getAssetsFile('game/VIDEO_on.png'),
    'LIVE': getAssetsFile('game/VIDEO_on.png'),
    'ARCADES': getAssetsFile('game/jieji.png'),
    'Cassino': getAssetsFile('home/pes (1).png'),
    'Cartas': getAssetsFile('home/pes (5).png'),
    'Popular': getAssetsFile('home/seraces (4).png'),

    // 默认图标
    'DEFAULT': getAssetsFile('game/gameTypeSlot.png')
  }

  return iconMap[gameType] || iconMap['DEFAULT']
}


const getAudioVendor = () => {
  GameApi.getAudioVendor(parmes.value).then((res) => {
    vendorList.value = res.data
    console.log('厂商列表数据:', vendorList.value)

    // 初始化选中状态
    initializeSelection()

    // 初始化选中状态后立即获取游戏列表
    setTimeout(() => {
      getGameList()
    }, 100) // 给一个小的延迟确保状态更新完成
  })
}


onMounted(() => {
    getAudioVendor()
    // 移除这里的 getGameList() 调用，因为已经在 getAudioVendor 中调用了
})
</script>

<style lang="scss" scoped>
.custom-nav-bar {
  height: 56px;
  box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.3), 0px -2px 22px 0px rgba(53,189,128,0.61);
  &>* {
    height: 100%;
  }
}
.game-limit {
    height: 100vh;
    overflow: hidden;
}

.type-selection {
    border-radius: 6px;
    height: 42px;
    overflow: hidden;
}

.type-scroll-container {
    height: 100%;
    overflow-x: auto;
    overflow-y: hidden;
}

.type-list {
    display: flex;
    height: 100%;
    min-width: max-content;
}

.type-item {
    min-width: 80px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 10px;
    cursor: pointer;
    border-radius: 6px;
    margin-right: 5px;
}

.type-icon {
    width: 20px;
    height: 20px;
    margin-right: 5px;
}

.type-name {
    font-size: 12px;
    white-space: nowrap;
}

.game-card {
    border-radius: 10px;
    text-align: center;
    position: relative;
    overflow: hidden;
    width: 79px;
    height: 106px;
}

.teonse {
    color: #ffffff !important;
    font-weight: bold;
}
</style>

<route lang="json5">
{
  name: 'gameLimit',
  path: '/gameLimit'
}
</route>
